/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Enum for partner invitation status
 */
export var PartnerInvitationStatusEnum;

(function (PartnerInvitationStatusEnum) {
  PartnerInvitationStatusEnum["PENDING"] = "pending";
  PartnerInvitationStatusEnum["ACCEPTED"] = "accepted";
  PartnerInvitationStatusEnum["FAILED"] = "failed";
  PartnerInvitationStatusEnum["CANCELED"] = "canceled";
})(PartnerInvitationStatusEnum || (PartnerInvitationStatusEnum = {}));